module.exports = __webpack_public_path__ + "img/1.1c67c3e7.png";